/**
 * Priority order for strategies (most used first). Multi-Strat sits at the
 * very top — it's a synthetic combined view (GFPB Mon/Wed/Fri + Tuesday
 * Special Tue + Thursday Special Thu) that surfaces the canonical Vector
 * Capital sleeve first.
 */
const STRATEGY_PRIORITY = [
  'Vector Master Strat',
  'Multi-Strat',
  'Sample Strategy (Demo)',
  'Grass Fed Prime Beef (Current version 2.1C)',
  'Tuesday Special (Previous 2.2A)',
  'Grass Fed Prime Beef 2.1',
  'Grass Fed Prime Beef 2.0',
  'Grass Fed Prime Beef',
  'Thursday Special',
  'BeefBowl',
  'BeefBowl 1 micro 100 trigger',
  'PrimeBeef',
  'Meat Popsicle',
  'Genki',
  'Filet Mignon'
];

/**
 * Sorts strategy names with priority strategies first, then alphabetically
 * @param {string[]} strategies - Array of strategy names from Google Sheet
 * @returns {string[]} - Sorted array with priority strategies first
 */
export function sortStrategies(strategies, options = {}) {
  if (!strategies || strategies.length === 0) {
    return [];
  }

  const { preserveOrder = false } = options;

  // User-defined Custom Multi-Strat combos use the `custom:<id>` prefix and
  // get pinned to the very top in the order they were added — they always
  // come before any built-in priority entry so the user's saved combos sit
  // first in every dropdown.
  const comboStrategies = [];
  const priorityStrategies = [];
  const otherStrategies = [];
  const prioritySet = new Set(STRATEGY_PRIORITY.map(s => s.toLowerCase()));

  // preserveOrder mode: the caller passes a list that is ALREADY in the
  // authoritative order (e.g. the admin Sheet Manager order returned by
  // /api/sheets). Keep combos pinned first (in their incoming order) and leave
  // every other sheet exactly as received — no re-sorting against the legacy
  // hardcoded STRATEGY_PRIORITY list, which would override the admin's order.
  if (preserveOrder) {
    const combos = [];
    const rest = [];
    strategies.forEach((strategy) => {
      if (typeof strategy === 'string' && strategy.startsWith('custom:')) combos.push(strategy);
      else rest.push(strategy);
    });
    return [...combos, ...rest];
  }

  strategies.forEach(strategy => {
    if (typeof strategy === 'string' && strategy.startsWith('custom:')) {
      comboStrategies.push(strategy);
    } else if (prioritySet.has(strategy.toLowerCase())) {
      priorityStrategies.push(strategy);
    } else {
      otherStrategies.push(strategy);
    }
  });

  // Sort priority strategies by their order in STRATEGY_PRIORITY
  priorityStrategies.sort((a, b) => {
    const indexA = STRATEGY_PRIORITY.findIndex(p => p.toLowerCase() === a.toLowerCase());
    const indexB = STRATEGY_PRIORITY.findIndex(p => p.toLowerCase() === b.toLowerCase());
    return indexA - indexB;
  });

  // Sort other strategies alphabetically
  otherStrategies.sort((a, b) => a.localeCompare(b));

  // Combine: combos first (user's saved order), then priority, then others.
  return [...comboStrategies, ...priorityStrategies, ...otherStrategies];
}

